module.exports = __webpack_public_path__ + "static/media/19.5772c8b0.jpg";